/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAddressListRequest = {
    sortField?: KiteAddressListRequest.sortField;
    sortDirection?: KiteAddressListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace KiteAddressListRequest {

    export enum sortField {
        BALANCE = 'BALANCE',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

